'use client'

import { PropsWithChildren, useEffect } from 'react'
import { LiveChatLoaderProvider } from 'react-live-chat-loader'
import { usePathname } from 'next/navigation'

import { CustomerInfo } from '../authentication'

type Props = PropsWithChildren & {
  customerInfo: CustomerInfo | undefined
}

export const IntercomProvider = ({ customerInfo, children }: Props): JSX.Element => {
  const pathname = usePathname()

  const handleRouteChange = () => {
    // @ts-ignore
    if (typeof window !== 'undefined') {
      // @ts-ignore
      window.intercomSettings = {
        // @ts-ignore
        app_id: process.env.NEXT_PUBLIC_INTERCOM_APP_ID ?? '',
        user_id: customerInfo?.customer?.id,
        name: customerInfo?.customer?.fullName,
        email: customerInfo?.organization?.email ?? customerInfo?.customer?.email,
        created_at: customerInfo?.customer?.createdAt,
        company: customerInfo?.organization
          ? {
              company_id: customerInfo?.organization?.id,
              name: customerInfo?.organization?.name,
              created_at: customerInfo?.organization?.createdAt,
            }
          : undefined,
      }
    }
  }

  useEffect(() => {
    handleRouteChange()
  }, [pathname])

  handleRouteChange()

  return (
    <LiveChatLoaderProvider
      providerKey={process.env.NEXT_PUBLIC_INTERCOM_APP_ID ?? ''}
      provider="intercom"
      idlePeriod={0}
    >
      {children}
    </LiveChatLoaderProvider>
  )
}
